import { getLocation } from '@/utils/get-location';

export type FeedbackRequest = {
  fields: {
    description: string;
    issuetype: {
      name: string;
    };
    project: {
      id: string;
    };
    summary: string;
  };
};

export type CreateFeedbackTicketProps = {
  feedbackText: string;
  pageTitle: string;
  feedbackType: string;
};

export const createFeedbackTicket = async (props: CreateFeedbackTicketProps): Promise<FeedbackRequest> => {
  const response = await fetch(`/api/feedback`, {
    method: 'POST',
    body: JSON.stringify({
      summary: `[Feedback] ${props.pageTitle}`,
      description: props.feedbackText,
      feedbackType: props.feedbackType,
      url: getLocation().href,
    }),
  });
  const results = (await response.json()) as FeedbackRequest;

  return results;
};
